
import styled from 'styled-components'

export const Container = styled.div<{ bgColor: string }>`
  border-radius: 15px;
  height: 46px;
  width: 46px;
  padding: 3px;
  background: ${({ bgColor }) => bgColor};
  justify-content: center;
  align-items: center;
  display: flex;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;

  color: #505887;
`
